const uniDirectionSerializer = (value) => typeof value === "string" || typeof value === "number" || typeof value === "boolean" ? value : typeof value === "undefined" ? "undefined" : JSON.stringify(value);

export { uniDirectionSerializer };
//# sourceMappingURL=json.mjs.map
